import { _footerDe as footer } from './footer/footer';
import { _cookiesDe as cookie } from './cookies/cookies';
import { _notificationsDe as notifications } from './notifications/notifications';
import { _alertsDe as alerts } from './alerts/alerts';
import { _sessionDe as session } from './session/session';
import { _rightMenuDe as rightMenu } from './menus/rightMenu';
import { _gamesTableDe as gamesTable } from './tables/gamesTable';
import { _modalsDe as modals } from './modals/modals';
import { _homePageDe as gameHomePage } from './gameHomePage/home';
import { _configDe as config } from './configuration/config';
import { _defaultDe as defaults } from './default';
import { _authDe as auth } from './configuration/authorizations';
import { _assignmentsDe as assignments } from './assignments/assignments';
import { _planningDe as planning } from './assignments/planning';
import { _sgaDe as sga } from './sga/sga';
import { _sgoDe as sgo } from './sgo/sgo';
import { _sigDe as sig } from './sig/sig';
import { _bipDe as bip } from './bip/bip';
import { _radioDe as radio } from './radio/radio';
import { _ticketDe as ticket } from './assignments/ticket';
import { _shopDe as shop } from './shop/shop';

export const de = {
    title: 'Spezielle Warnungen',
    module: 'Rollenspielmodul',
    chooseLangage: 'Sprache wählen',
    account: 'Konto',
    disconnect: 'Abmelden',
    refresh: 'Aktualisieren',
    loading: 'Laden',
    load: 'Laden',
    to: 'An',
    send: 'Senden',
    allRights: 'Alle Rechte vorbehalten',
    create: 'Erstellen',
    game: 'Spiel',
    changeThemeDark: 'Dunkles Thema verwenden',
    changeThemeLight: 'Helles Thema verwenden',
    yes: 'Ja',
    no: 'Nein',
    delete: 'Löschen',
    cancel: 'Abbrechen',
    validate: 'Bestätigen',
    close: 'Schließen',

    defaults,
    footer,
    cookie,
    notifications,
    alerts,
    session,
    rightMenu,
    gamesTable,
    modals,
    gameHomePage,
    config,
    auth,
    assignments,
    planning,
    sga,
    sgo,
    sig,
    bip,
    radio,
    ticket,
    shop,
};
